export const createDebetCardsFormRepository = (appFetch) => {
    return {
        model(options = {}) {
            return appFetch.get('/cabinet/card-request/api/load', options);
        },
        statistic(body, options = {}) {
            return appFetch.post('/cabinet/card-request/api/record-stat', body, options);
        },
        potential(body, options = {}) {
            return appFetch.post('/cabinet/card-request/api/send/step1', body, options);
        },
        orderNew(body, options = {}) {
            return appFetch.post('/cabinet/card-request/api/send', body, options);
        },
        orderAdditional(body, options = {}) {
            return appFetch.post('/cabinet/card-request/api/send/additional', body, options);
        },
        rerelease(body, options = {}) {
            return appFetch.post('/cabinet/card-request/api/send/rerelease', body, options);
        },
        short(body, options = {}) {
            return appFetch.post('/cabinet/mass-compromise-case/api/send', body, options);
        },
        reissue(slug, body, options = {}) {
            return appFetch.post(`/cabinet/card-request/api/send/${slug}`, body, options);
        },
    };
};
